import React, { useState, useEffect } from "react";
import QRCode from "react-qr-code";
import { useUserContext } from "../../context/userContext";
import fetchWithRefresh from "../../utils/fetchWithRefresh";
import { useHeaderContext } from "../../context/headerContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";
import { LogErrors } from "../../utils/LogErrors";

export default function VenueShop()  {
  const { selectedVenue } = useUserContext();
  const [qrCode, setQRCode] = useState([]);
  const [loading, setLoading] = useState(true);
  const { setTitle, setBackButton, setBackButtonFunc } = useHeaderContext();

  const { user, logout, updateTokens } = useUserContext();

  const navigate = useNavigate();

  useEffect(() => {
    fetchQRCode();
  }, []);

    useEffect(() => {
      setTitle("Venue Shop");
      setBackButton(true);
  
      const handleBack = () => {
        navigate(-1);
      };
  
      setBackButtonFunc(handleBack);
    }, []);


const fetchQRCode = async () => {
  try {
    return await Sentry.startSpan({ name: "Fetch QR Code", op: "http.request" }, async (span) => {
      const url = `${import.meta.env.VITE_API_URL}Venue/FetchShopQRCodeForVenue?venueId=${selectedVenue?.OrgID}`;
      span.setAttribute("http.url", url);
      span.setAttribute("venueId", selectedVenue?.OrgID);

      const response = await fetchWithRefresh(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      }, logout, updateTokens, (message) => { toast.info(message); });

      if (response.ok) {
        const data = await response.json();
        span.setStatus("ok");
        LogErrors(user, logout, updateTokens, data);
        setQRCode(data);
      } else {
        const errorMessage = `Error fetching QR code. Status: ${response.status}`;
        span.setStatus("error");
        Sentry.captureMessage(errorMessage, "warning");
        LogErrors(user, logout, updateTokens, errorMessage);
      }

      setLoading(false);
    });
  } catch (error) {
    Sentry.captureException(error, { extra: { venueId: selectedVenue?.OrgID } });
    LogErrors(user, logout, updateTokens, "Error fetching QR code: " + error);
  }
};


if(loading){
  return (
    <div className="flex justify-center items-center h-full">
        <div className="loading loading-spinner loading-lg">Loading...</div>
    </div>
  )
}

return (
  <div className="flex flex-col items-center gap-[24px] align-middle justify-center h-full">
    <p className="text-center text-[19px] leading-[28px]">Scan this QR code to order your <span className="capitalize">{qrCode?.OrgPartnerFriendlyName}</span> band</p>
    <QRCode 
      size={100}
      style={{ height: "auto", maxWidth: "240px", width: "100%" }}
      value={qrCode?.HumanReadable || ""}
      viewBox={`0 0 256 256`}
    />
  </div>
);
}